import { z } from 'zod';

/**
 * A CandyJar (GalateaTV) show that is the video adaptation of a Galatea book/story.
 * Lighter than {@link CJPromoShelfSeries} (no episodes) — used for the "adapted to movie"
 * Summary placeholder and the "movies from books you've read" shelf, which only need the
 * cover, title and a deep link into CandyJar.
 */
export const CandyJarShow = z.object({
  /** GalateaTV series id. */
  seriesId: z.number(),
  /** The Galatea story id this show is adapted from (series.galatea_original_story_id). */
  galateaStoryId: z.string(),
  title: z.string(),
  slug: z.string(),
  coverImageUrl: z.string(),
  /** Base deep link into the CandyJar show (auth token appended client-side for same-account open). */
  deepLink: z.string(),
});
export type CandyJarShow = z.infer<typeof CandyJarShow>;
